import * as styles from "./Toolbar.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { ToolbarProps } from "./Toolbar.types";

export function Toolbar({
  divider = true,
  align = "between",
  wrap = true,
  size = "md",
  className,
  ...props
}: ToolbarProps): JSX.Element {
  return (
    <div
      data-slot="toolbar"
      className={clsx(
        styles.toolbar({ size, divider, align, wrap }),
        className,
      )}
      {...props}
    />
  );
}
